import { defineGameCard, onResolve, unitTarget } from '../authoring/index.js';
import { isSlimeUnit, plannedUnitId, slimeSetDependencies } from './slime-helpers.js';
export const SingleMassCard = defineGameCard({
    id: 'single_mass',
    gameplay: {
        type: 'SPELL', cost: 6,
        planning: {
            target: unitTarget({
                side: 'ally',
                cardinality: { min: 1, max: 1 },
                where: ({ unit }) => unit.traits.includes('SLIME'),
            }),
        },
    },
    presentation: {
        name: 'Единая масса',
        description: 'Выберите своего слизня. Он поглощает всех остальных ваших слизней на поле.',
        glyph: {
            colors: ['#9FDC64', '#82C84C', '#4097CA', '#10213A', '#2E6692'],
            rows: [
                '.1211344333...211...',
                '.111113334444151111.',
                '12111534333333211111',
                '22555343355555522211',
                '2444333555455344...2',
                '44433554445455334...',
                '4343554...4.445534..',
                '4343554.......45534.',
                '433354.........45534',
                '443554........454533',
                '343554........455553',
                '3443554.......453453',
                '4344454......4453453',
                '.4334454....45553453',
                '.511554...4445534453',
                '1112154444554552111.',
                '21151155555445511111',
                '22111155554553211112',
                '.5222244455534212225',
                '........44444..555..',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeSetDependencies(),
    abilities: [onResolve((ctx) => {
            const receiverId = plannedUnitId(ctx, 'target');
            const receiver = receiverId === undefined ? null : ctx.q.instance(receiverId);
            if (receiver === null)
                return;
            const donors = ctx.q.unitsOf(receiver.controllerId)
                .filter((unit) => unit.id !== receiver.id && isSlimeUnit(unit));
            if (donors.length > 0)
                ctx.ops.absorbCards(receiver.id, donors.map((donor) => donor.id));
        })],
    ui: {
        mechanics: ['absorb'],
        planning: { steps: { target: { label: 'Выберите слизня-получателя' } } },
    },
});
//# sourceMappingURL=single_mass.js.map